import { useFileDialog } from '@vueuse/core';
import { getRandomId } from '@sbs/uikit-constructor/src/lib/utils/helpers.js';
import { ACCEPT_VIDEO_EXTENSION, MAX_VIDEO_FILE_BYTES } from '@/components/Blocks/BlockVideo/constants.js';
import { getErrorMsg } from '@/utils/helpers.js';
import useSnackbar from '@/hooks/snackbars.js';
import { validateFile } from '@/utils/validators.js';

export const useSelectVideoFile = handleFileSelected => {
    const { createSnackbar } = useSnackbar();

    const videoExtensions = ACCEPT_VIDEO_EXTENSION.map(ext => `video/${ext}`).map(ext => ext.replace('.', ''));

    const { onChange, open } = useFileDialog({
        multiple: false,
        reset: true,
        accept: videoExtensions,
    });

    onChange(files => {
        try {
            if (!files) return;

            const file = files[0];

            validateFile(file, {
                types: videoExtensions,
                maxSize: MAX_VIDEO_FILE_BYTES,
            });

            file.id = getRandomId();

            handleFileSelected(file);
        } catch (error) {
            createSnackbar({
                type: 'error',
                message: getErrorMsg(error) || 'Ошибка загрузки',
            });
        }
    });

    return {
        open,
    };
};

export const getEventVideoUploadKey = eventId => `video-event-${eventId}`;

export const getVideoPath = ({ dayIndex, eventIndex } = {}) => {
    const isVideoInSchedule = typeof dayIndex === 'number' && typeof eventIndex === 'number';

    return isVideoInSchedule
        ? `/data/content/schedule/items/${dayIndex}/content/schedule_items/items/${eventIndex}/content/video`
        : '/data/content/video';
};
